import { checkAbilities } from './checkAbilities';
import { checkCustomizationStep } from './checkCustomizationStep';
import { requireAuth } from './requireAuth';
import { savePrevious } from './savePrevious';

export default [requireAuth, checkAbilities, savePrevious, checkCustomizationStep];
